import { fetchData } from '..';
export async function getRemoteAppConfig(configLocation, abortController) {
    const requestInit = {
        cache: 'no-store',
    };
    return await fetchData(configLocation, abortController, requestInit);
}
